import { Row } from "antd";
import { Link } from "react-router-dom";
import ROUTES from "../../../../configs/routesConfig";

type FormItemProps = {
  label: string;
  value: string;
  accId?: string;
};

export const FormItem = ({ label, value, accId }: FormItemProps) => {
  return (
    <Row className="form-item mt-4">
      <span className="label">{label}</span>
      <Row className="val__container">
        {!accId ? (
          <span>{value}</span>
        ) : (
          <Link to={`${ROUTES.ACCOUNTS}/${accId}`} target="_blank">
            <span className="ant-btn-link">{value}</span>
          </Link>
        )}
      </Row>
    </Row>
  );
};
